import { Component } from '@angular/core';
import { HostProfilePropertiesService } from './shared/hostProfileProperties.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor(
        private hostProfileService: HostProfilePropertiesService,
        private title: Title
    )
    {
        //override title, favicon and splash

        this.hostProfileService.changeFavicon(this.hostProfileService.hostProperties.iconLogo)
        this.hostProfileService.changeSplashLogo()
        this.title.setTitle(this.hostProfileService.hostProperties.tittle)

    }
}
